import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AddEmployeeService } from '../master/addEmplyee.service';

declare var google: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit,AfterViewInit, OnDestroy {
  loginForm!: FormGroup;
  submitted = false;
  username: string = '';
  password: string = '';
  public userResponce: any;
  public userObject: any;
  public roles: Array<String> = [];
  private notifier: NotifierService;
  public firstName: any = '';
  public showAlert: boolean = false;
  public matchNotFoundInDB: boolean = false;
  public userName: any = '';
  public userNameSubmitted: boolean = false;
  public mailSentSuccessfully: boolean = false;
  @ViewChild('googleButton', { static: false })
  googleButton!: ElementRef;
  private googleInitialized = false;


  constructor(private formBuilder: FormBuilder,
    private route: Router,
    notifier: NotifierService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private authService: AuthenticationService, private addEmployeeService: AddEmployeeService, private router: Router
  ) {
    this.notifier = notifier;
  }

  private popStateHandler = () => {
    history.pushState(null, '', location.href);
  };

  ngOnDestroy(): void {
    window.removeEventListener('popstate', this.popStateHandler);
  }

  ngOnInit(): void {
    //reactive form validations
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.minLength(1)]],
      password: ['', Validators.required],
    })
    history.pushState(null, '', location.href);
    window.addEventListener('popstate', this.popStateHandler);
  }

  ngAfterViewInit(): void {
    this.initializeGoogleLogin();
  }

  initializeGoogleLogin(): void {

  // Google script may still be loading because it is async
  if (typeof google === 'undefined' ||
      !google.accounts ||
      !google.accounts.id) {

    console.log(
      'Google Identity Services not loaded yet. Retrying...'
    );

    setTimeout(() => {
      this.initializeGoogleLogin();
    }, 500);

    return;
  }

  if (
    this.googleInitialized ||
    !this.googleButton
  ) {
    return;
  }

  console.log(
    'Initializing Google Identity Services...'
  );

  google.accounts.id.initialize({

    client_id:
      '831116776806-1q8p728ie0cat4rp39f9cfpg3ck5aaum.apps.googleusercontent.com',

    callback: (response: any) => {

      console.log(
        'Google credential response:',
        response
      );

      this.handleGoogleCredential(response);

    }

  });

  google.accounts.id.renderButton(

    this.googleButton.nativeElement,

    {
      type: 'standard',
      theme: 'outline',
      size: 'large',
      text: 'signin_with',
      shape: 'rectangular',
      logo_alignment: 'left',
      width: 300
    }

  );

  this.googleInitialized = true;

  console.log(
    'Google Sign-In button rendered successfully.'
  );
}
  
handleGoogleCredential(response: any): void {

  console.log('Google credential response:', response);

  if (!response || !response.credential) {
    console.error('Google credential is missing');

    this.notifier.notify(
      'error',
      'Google login failed. No credential received.'
    );

    return;
  }

  const idToken = response.credential;

  try {

    const profile = this.decodeGoogleToken(idToken);

    console.log('Google profile:', profile);

    const email = profile.email;

    if (!email) {

      this.notifier.notify(
        'error',
        'Email was not received from Google.'
      );

      return;
    }

    console.log('Google email:', email);

    // Optional: keep these if you need them later
    // sessionStorage.setItem('googleEmail', email);
    // sessionStorage.setItem('googleIdToken', idToken);

    // Check whether this email exists in HRMS
    this.checkUserByEmail(email);

  } catch (error) {

    console.error(
      'Unable to decode Google token:',
      error
    );

    this.notifier.notify(
      'error',
      'Invalid Google login response.'
    );
  }
}

decodeGoogleToken(token: string): any {

  const parts = token.split('.');

  if (parts.length !== 3) {
    throw new Error('Invalid Google JWT');
  }

  const payload = parts[1];

  const decodedPayload = atob(
    payload
      .replace(/-/g, '+')
      .replace(/_/g, '/')
  );

  return JSON.parse(decodedPayload);
}

checkUserByEmail(email: string): void {

  this.spinner.show();

  const api =
    'user/user-by-email?email=' +
    encodeURIComponent(email);

  this.authService
    .validateUser(api)
    .subscribe(

      (response: any) => {

        this.spinner.hide();

        /*
         * Existing user
         */
        if (
          response &&
          response.data &&
          response.data.userName
        ) {

          const userName =
            response.data.userName;

          const password =
            response.data.password;

          this.loginGoogleAccount(
            userName,
            password
          );

        }

        /*
         * User does not exist
         */
        else {

          console.log(
            'Google email does not exist in HRMS.'
          );

          this.notifier.notify(
            'error',
            'Email not found in system. Please contact administrator.'
          );

        }

      },

      (error: any) => {

        this.spinner.hide();

        console.error(
          'USER BY EMAIL ERROR:',
          error
        );

        console.error(
          'Status:',
          error?.status
        );

        console.error(
          'Error body:',
          error?.error
        );

        this.notifier.notify(
          'error',
          error?.error?.message ||
          'Email not found in system. Please contact administrator.'
        );

      }

    );
}



loginGoogleAccount(
  userName: string,
  password: string
): void {

  this.spinner.show();

  this.userObject = {
      "userName": userName,
      "password": password
    }

  this.authService
    .authenticationLogin(this.userObject)
    .subscribe(

      (res: any) => {

        console.log(
          'HRMS LOGIN RESPONSE:',
          res
        );

        this.userResponce = res;
        localStorage.setItem('token', this.userResponce.token);
        localStorage.setItem("type", "");
        localStorage.setItem("userName", this.userResponce.userName);
        sessionStorage.setItem("firstName", this.userResponce?.firstName || "");
        sessionStorage.setItem("empId", this.userResponce.id);
        sessionStorage.setItem("designation", this.userResponce.contactName);
        sessionStorage.setItem("externalReportingHeadMail", this.userResponce.contactNumber);
        this.roles = this.userResponce.roles;
        sessionStorage.setItem("role", "" + this.roles[0]);
       // this.fetchEmployeeDetails();
        console.log("role", this.roles[0]);
        // this.route.navigateByUrl('HRMS');
        // console.log('aaaaaaa');
        this.spinner.hide();
        //  sessionStorage.setItem('token',this.userResponce.token)
        if (sessionStorage.getItem("role") == "ROLE_SUPER_ADMIN") {
          this.route.navigateByUrl('select-company');

        } else if (sessionStorage.getItem("role") == "ROLE_CANDIDATE") {
          sessionStorage.setItem("companyId", this.userResponce.company.companyId);
          sessionStorage.setItem("companyName", this.userResponce.company.companyName);
          //this.route.navigateByUrl('/HRMS/Company/edit-company');
          this.route.navigateByUrl('HRMS/Employee-Onboarding/onboarding-employee');
        } else {
          sessionStorage.setItem("companyId", this.userResponce.company.companyId);
          sessionStorage.setItem("companyName", this.userResponce.company.companyName);
          //this.route.navigateByUrl('/HRMS/Company/edit-company');
          sessionStorage.setItem('Edit-employeeId', this.userResponce.id.toString());
          sessionStorage.setItem('Edit-employee-role', "" + this.roles[0]);
          this.route.navigateByUrl('HRMS/Master/view-employee/' + this.userResponce.id.toString());
        }
  setTimeout(() => {
    window.location.reload();
  }, 1500);
      },

      (error: any) => {

        this.spinner.hide();

        console.error(
          'HRMS GOOGLE LOGIN ERROR:',
          error
        );

        this.notifier.notify(
          'error',
          error?.error?.message ||
          'Google login failed.'
        );

      }

    );
}


  // convenience getter for easy access to form fields
  get form() {
    return this.loginForm.controls;
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    /** spinner starts on init */
    this.spinner.show();
    this.username = this.loginForm.value.username;
    this.password = this.loginForm.value.password;
    //user object   
    this.userObject = {
      "userName": this.username,
      "password": this.password
    }
    localStorage.setItem('token', " ");
    this.authService.authenticationLogin(this.userObject)
      .subscribe((res) => {
        this.userResponce = res;
        sessionStorage.setItem("companyCountryName", this.userResponce?.company?.country?.countryName);
        localStorage.setItem('token', this.userResponce.token);
        localStorage.setItem("type", "");
        localStorage.setItem("userName", this.userResponce.userName);
        sessionStorage.setItem("firstName", this.userResponce?.firstName || "");
        sessionStorage.setItem("empId", this.userResponce.id);
        sessionStorage.setItem("designation", this.userResponce.contactName);
        sessionStorage.setItem("externalReportingHeadMail", this.userResponce.contactNumber);
        this.roles = this.userResponce.roles;
        sessionStorage.setItem("role", "" + this.roles[0]);
       // this.fetchEmployeeDetails();
        console.log("role", this.roles[0]);
        // this.route.navigateByUrl('HRMS');
        // console.log('aaaaaaa');
        this.spinner.hide();
        //  sessionStorage.setItem('token',this.userResponce.token)
        if (sessionStorage.getItem("role") == "ROLE_SUPER_ADMIN") {
          this.route.navigateByUrl('select-company');

        } else if (sessionStorage.getItem("role") == "ROLE_CANDIDATE") {
          sessionStorage.setItem("companyId", this.userResponce.company.companyId);
          sessionStorage.setItem("companyName", this.userResponce.company.companyName);
          //this.route.navigateByUrl('/HRMS/Company/edit-company');
          this.route.navigateByUrl('HRMS/Employee-Onboarding/onboarding-employee');
        } else {
          sessionStorage.setItem("companyId", this.userResponce.company.companyId);
          sessionStorage.setItem("companyName", this.userResponce.company.companyName);
          //this.route.navigateByUrl('/HRMS/Company/edit-company');
          sessionStorage.setItem('Edit-employeeId', this.userResponce.id.toString());
          sessionStorage.setItem('Edit-employee-role', "" + this.roles[0]);
          this.route.navigateByUrl('HRMS/Master/view-employee/' + this.userResponce.id.toString());
        }
        //   //  this.route.navigateByUrl('sidenavbar');
        // setTimeout(() => {
        //   this.route.navigateByUrl('HRMS/dashboard');
        //   this.spinner.hide();
        //   this.notifier.notify('success', "Welcome User:- "+ this.userResponce.userName+"");
        // }, 500);
      },
        (error) => {
          error instanceof HttpErrorResponse
          console.log(error)
          // this.route.navigateByUrl('dashboard');
          //this.route.navigateByUrl('select-company');
          setTimeout(() => {
            this.spinner.hide();
            this.notifier.notify('error', error.error.message);
            // this.spinner.hide();
            // this.notifier.notify('success', "Welcome User:- "+ this.username+"");
          }, 500);
        }
      )
  }
  // fetchEmployeeDetails() {
  //   this.addEmployeeService.getEmployeeById(this.userResponce.id)
  //     .subscribe((data: any) => {
  //       this.firstName = data.data.firstName;
  //       sessionStorage.setItem("firstName", this.firstName);
  //     })
  // }

  handleForgotPassword() {
    this.showAlert = false;
    this.matchNotFoundInDB = false;
    this.userName = '';
    (<any>$('#alert_modal')).modal('show');
  }
  handleRegisterPage(){
    this.route.navigateByUrl('registerOrg');
  }

  submitUserName() {
    this.userNameSubmitted = true;
    if (this.userName) {
      this.spinner.show();
      let api = 'user/validate?userName=' + this.userName;
      this.authService.validateUser(api).subscribe((data: any) => {
        this.spinner.hide();
        this.matchNotFoundInDB = data.data;
        if (!this.matchNotFoundInDB) {
          this.sendMailToUser();
        }
      },
        (error) => {
          this.spinner.hide();
          console.log(error);
        })
    }
  }

  changeUserName() {
    this.matchNotFoundInDB = false;
  }
 

  sendMailToUser() {
    if (this.userName) {
      this.spinner.show();
      let api = 'user/sendEmail?userName=' + this.userName;
      this.authService.validateUser(api).subscribe((data: any) => {
        this.spinner.hide();
        this.mailSentSuccessfully = data.data;
        if (this.mailSentSuccessfully) {
          this.notifier.notify('success', 'Mail Sent Successfully!');
          this.showAlert = true;
        } else {
          this.notifier.notify('error', 'Mail Id not Found with this user, Please contact to Admin!');
        }
      },
        (error) => {
          this.spinner.hide();
          console.log(error);
        })
    }
  }
}
